import { calendar_v3 } from "googleapis";

export function formatEventDateRange(event: calendar_v3.Schema$Event) {
  const startDateString = event.start?.dateTime ?? event.start?.date ?? "";
  const endDateString = event.end?.dateTime ?? event.end?.date ?? "";

  if (!startDateString || !endDateString) {
    return "";
  }

  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  if (startDate.toDateString() === endDate.toDateString()) {
    return startDate.toLocaleDateString();
  }

  return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
}
